import { Pipe, PipeTransform } from '@angular/core';
import { getRatingCategory } from '@sona/shared-util-common';
import { RatingCategory } from '@sona/shared-model-common';

/**
 * Gets the rating category for a given percentage score.
 */
@Pipe({
    name: 'sonaRatingCategory',
    standalone: true
})
export class SonaRatingCategoryPipe implements PipeTransform {
    transform(percentageScore?: number | null): RatingCategory | undefined {
        if (percentageScore == null) {
            return undefined;
        }

        return getRatingCategory(percentageScore);
    }
}
